import { handleActions } from "redux-actions";

import {
  SET_LANGUAGE,
  CLEAN_NAV,
  SET_DATA_LINE,
  SET_FILTER_PART,
  SET_FILTER_PART_DES,
  SET_FILTER_CODE,
  SET_FILTER_TASK,
  SET_FILTER_VIV,
  SET_FILTER_VARIETY,
  SET_FILTER_BATCH,
  SET_FILTER_ARTICLE,
  SET_FILTER_LOCATION,
  SET_FILTER_SECT,
  SET_FILTER_USER,
} from "../../constants/index";
import { filterArticle } from "../actions/ArticleActions";

export const nav = handleActions(
  {
    [CLEAN_NAV]: () => ({}),
    [SET_LANGUAGE]: (state, action) => ({
      ...state,
      language: action.payload,
    }),
    [SET_DATA_LINE]: (state, action) => ({
      ...state,
      line: action.payload,
    }),
    [SET_FILTER_PART]: (state, action) => ({
      ...state,
      filterPart: action.payload,
    }),
    [SET_FILTER_PART]: (state, action) => ({
      ...state,
      filterPart: action.payload,
    }),
    [SET_FILTER_PART_DES]: (state, action) => ({
      ...state,
      filterPartDes: action.payload,
    }),
    [SET_FILTER_CODE]: (state, action) => ({
      ...state,
      filterCode: action.payload,
    }),
    [SET_FILTER_TASK]: (state, action) => ({
      ...state,
      filterTask: action.payload,
    }),
    [SET_FILTER_VIV]: (state, action) => ({
      ...state,
      filterViv: action.payload,
    }),
    [SET_FILTER_VARIETY]: (state, action) => ({
      ...state,
      filterVariety: action.payload,
    }),
    [SET_FILTER_BATCH]: (state, action) => ({
      ...state,
      filterBatch: action.payload,
    }),
    [SET_FILTER_ARTICLE]: (state, action) => ({
      ...state,
      filterArticle: action.payload,
    }),
    [SET_FILTER_LOCATION]: (state, action) => ({
      ...state,
      filterLocation: action.payload,
    }),
    [SET_FILTER_SECT]: (state, action) => ({
      ...state,
      filterSect: action.payload,
    }),
    [SET_FILTER_USER]: (state, action) => ({
      ...state,
      filterUser: action.payload,
    }),
  },
  {}
);
